<template>
  <div class="w-full">
    <section class="bg-gradient-to-b from-blue-50 to-white py-20">
      <div class="container mx-auto px-4">
        <h1 class="text-3xl font-bold text-blue-900 mb-8 text-center">
          Contact Us
        </h1>
        <div class="flex flex-col lg:flex-row gap-12">
          <div class="lg:w-1/2">
            <h2 class="text-xl font-semibold text-blue-900 mb-6">
              Send Us a Message
            </h2>
            <ContactForm />
          </div>
          <div class="lg:w-1/2">
            <h2 class="text-xl font-semibold text-blue-900 mb-6">
              Contact Information
            </h2>
            <div class="space-y-6">
              <div class="flex items-start">
                <MapPin
                    size="24"
                    class="text-amber-500 mr-4 mt-1"
                />
                <div>
                  <h3 class="font-medium text-blue-900">
                    Address
                  </h3>
                  <p class="text-blue-800/70">
                    New York City, NY
                  </p>
                </div>
              </div>
              <div class="flex items-start">
                <Phone
                    size="24"
                    class="text-amber-500 mr-4 mt-1"
                />

                <div>
                  <h3 class="font-medium text-blue-900">
                    Phone
                  </h3>
                  <a
                      href="tel:+12014856060"
                      class="text-blue-800/70 hover:text-amber-500"
                  >
                    +1 201-485-6060
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ContactForm  from '../components/ContactForm.vue';

import { MapPin } from 'lucide-vue-next';



import { Phone } from 'lucide-vue-next';

export default {
  components: {
    ContactForm,
    MapPin,
    Phone,
  },
};
</script>